import {
  FETCH_CUSTOMER_ESCALATION_COUNT_SUCCESS,
  UPDATE_CUSTOMER_ESCALATION_COUNT
} from '../actions/customerEscalation';

const initialState = {
  customerEscalationCount: 0
};

export default function customerEscalationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CUSTOMER_ESCALATION_COUNT_SUCCESS:
    case UPDATE_CUSTOMER_ESCALATION_COUNT:
      return {
        ...state,
        customerEscalationCount: action.payload
      };
    
    default:
      return state;
  }
}
